module.exports = __webpack_public_path__ + "static/media/ensiasLogo.be8bb4ba.jpg";